import { render, staticRenderFns } from "./GerenciamentoTransporte.vue?vue&type=template&id=754fd40b"
import script from "./GerenciamentoTransporte.vue?vue&type=script&lang=js"
export * from "./GerenciamentoTransporte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports